import { Component,OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {ReferFriendsPage} from '../referfriends/referfriends';
import {HomePage} from'../home/home';
//import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
import { Contacts, Contact, ContactField, ContactName } from '@ionic-native/contacts';
import { LoadingController } from 'ionic-angular';
import {JsonData} from '../home/dataaa';


@Component({
	selector: 'page-invitefriend',
	templateUrl: 'invitefriend.html',
	providers: [Contacts,JsonData]
})
export class InviteFriendPage implements OnInit {
	disabStarter:string;
	
	// public allContacts: any
	//allContacts:Array<any>;
	//displayContact:any;
	contact:Array<JsonData>;
	
	constructor(public loading: LoadingController,public navCtrl: NavController,private contacts: Contacts) {
		
	}
	
	ngOnInit()
	{
		
		//this.helloOne();
		var sentContact = window.localStorage.getItem("sentReferal");
		this.contact=JSON.parse(sentContact);
	 	 
	}
	
	
	
	
	invitefriend()
	{
		/*this.contacts.find(['*']).then((contacts)=>{
			this.allContacts=contacts;
			}) 
		//	alert("all Contact===>"+JSON.stringify(this.allContacts));
		
		for(var i=0;i<this.allContacts.length;i++)
		{
			this.displayContact=this.allContacts[i]._objectInstance;
			//alert("Contact Name===>"+JSON.stringify(this.displayContact.displayName ));
			if(this.displayContact.phoneNumbers!=null){
				//alert("Phone Numberssss===>"+JSON.stringify(this.displayContact.phoneNumbers[0].value));
				//var callPayTm = JSON.stringify({"userid":userid,"mobileno":mobileno,"amount":this.sendBillamt});
			}
		}*/
		this.navCtrl.push(ReferFriendsPage);
	}
	
	bookfood()
	{
		this.navCtrl.push(HomePage);
	}
}



// WEBPACK FOOTER //
// ./src/pages/invitefriend/invitefriend.ts